import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import { dynamicDataAttribute } from 'helpers/utils'
import Heading from './Heading'

const Section = ({
  noHeading = false,
  isCheckout = false,
  threeStepper = false,
  children,
  className,
  targetId,
  ...props
}) =>
  <Wrapper
    data-max-width
    data-section
    { ...dynamicDataAttribute(`section-${targetId || 'appointment-summary'}`) }
    id={ noHeading ? targetId : undefined }
    className={ className }
    isCheckout={ isCheckout }
    threeStepper={ threeStepper }>
    {
      !noHeading &&
        <Heading data-at-quote-heading targetId={ targetId } { ...props } />
    }
    { children }
  </Wrapper>

Section.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
  isCheckout: PropTypes.bool,
  noHeading: PropTypes.bool,
  targetId: PropTypes.string,
  threeStepper: PropTypes.bool
}

export default Section

const Wrapper = styled.div`
  ${props => !props.isCheckout && css`
    border-bottom: 1px solid ${Theme.colors.light_grey};
  `}
  ${Mixin.responsive('padding', '40px 0 0', '33px 0 14px')}
  ${props => props.threeStepper && css`
    && {
      padding-top: 0;
    }
  `}
  ${Mixin.responsive('margin', '0 0 40px 0', '0 16px 20px')}
  ${Mixin.clearFix()}
`
